import React, { useEffect, useState } from "react";
// import { Box, CircularProgress,Typography } from "@mui/material";
import Accordion from "react-bootstrap/Accordion";
import doneIcon from "../../../assets/images/svg/newDesign/doneIcon.svg";
import profileIcon from "../../../assets/images/svg/newDesign/profileIcon.svg";
import vrification from "../../../assets/images/svg/newDesign/vrification.svg";
import vrificationDone from "../../../assets/images/svg/newDesign/vrificationDone.svg";
import "./Sidebar.scss";

const ProfileSetup = ({ progress }) => {
  const [activeKey, setActiveKey] = useState("1"); // Set the default active key to ensure the first Accordion remains closed.

  const handleToggle = (key) => {
    if (key !== "0" && key !== "2") {
      setActiveKey(key); // Update the state only if the key is not "0"
    }
  };

  const profileVerificationPercentage = parseInt(
    progress?.profile_completion_percentage
  );

  return (
    <>
      <div className="newSidbarUi">
        <Accordion
          activeKey={activeKey}
          onSelect={handleToggle}
          defaultActiveKey="1"
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="sidebarNew">
                <img src={doneIcon} className="img-fluid" alt="Done Icon"></img>
                <h5>Sign up</h5>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <div className="sidebarNew">
                {profileVerificationPercentage === 100 ? (
                  <img
                    src={doneIcon}
                    className="img-fluid"
                    alt="Done Icon"
                  ></img>
                ) : (
                  <img
                    src={profileIcon}
                    className="img-fluid"
                    alt="Profile Icon"
                  ></img>
                )}

                <h5>Profile Completion</h5>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <div className="pagination_sidebar current_box d-flex">
                <div className="details_sidebar">
                  <h5>About</h5>

                  <ul className="circle_list">
                    <li
                      className={`${
                        profileVerificationPercentage >= 0 &&
                        profileVerificationPercentage < 10
                          ? "list01 current"
                          : profileVerificationPercentage >= 10
                          ? "list01 listactive"
                          : "list01"
                      }`}
                    >
                      Personal Information
                    </li>
                    <li
                      className={
                        profileVerificationPercentage >= 10 &&
                        profileVerificationPercentage < 20
                          ? "list01 current"
                          : profileVerificationPercentage >= 20
                          ? "list01 listactive"
                          : "list01"
                      }
                    >
                      Practice Details
                    </li>
                    <li
                      className={
                        profileVerificationPercentage >= 20 &&
                        profileVerificationPercentage < 40
                          ? "list01 current"
                          : profileVerificationPercentage >= 40
                          ? "list01 listactive"
                          : "list01"
                        }
                    >
                      Bank Details
                    </li>
                  </ul>
                </div>
              </div>
              <div className="pagination_sidebar  d-flex">
                <div className="details_sidebar ">
                  <h5>Qualification</h5>

                  <ul className="circle_list">
                    <li
                      className={ 
                        profileVerificationPercentage >= 40 &&
                        profileVerificationPercentage < 70
                          ? "list01 current"
                          : profileVerificationPercentage >= 70
                          ? "list01 listactive"
                          : "list01"
                        }
                    >
                      Education | Experience
                    </li>
                  </ul>
                </div>
              </div>
              <div className="pagination_sidebar  d-flex">
                <div className="details_sidebar">
                  <h5>Consultation</h5>

                  <ul className="circle_list">
                    <li
                      className={ 
                        profileVerificationPercentage >= 70 &&
                        profileVerificationPercentage < 100
                          ? "list01 current"
                          : profileVerificationPercentage >= 100
                          ? "list01 listactive"
                          : "list01"
                        }
                    >
                      Online | Clinic Visit
                    </li>
                  </ul>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <div className="sidebarNew">
                {profileVerificationPercentage === 100 ? (
                  <img
                    src={vrificationDone}
                    className="img-fluid"
                    alt="Done Icon"
                  ></img>
                ) : (
                  <img
                    src={vrification}
                    className="img-fluid"
                    alt="Done Icon"
                  ></img>
                )}
                <h5>Profile Verification</h5>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};
export default ProfileSetup;
